// extracted by mini-css-extract-plugin
export default {"container":"WarningText_container__QGqKn"};